import {
  SET_LOGIN,
  SET_LOGIN_LOADING,
  SET_LOGIN_ERROR,
  SET_AUTH_SESSION,
  SET_USER_PROFILE,
  CLEAR_AUTH_SESSION,
} from "../../../actions/authAction/loginAction";

const readStorage = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const initialState = {
  data: "",
  auth: readStorage("auth"),
  profile: readStorage("userProfile"),
  loading: false,
  error: null,
};
const loginReducer = (state, action) => {
  state = state || initialState;
  switch (action.type) {
    case SET_LOGIN:
      return {
        ...state,
        data: action.data,
      };
    case SET_AUTH_SESSION:
      return {
        ...state,
        auth: action.auth,
        error: null,
      };
    case SET_USER_PROFILE:
      return {
        ...state,
        profile: action.profile,
      };
    case CLEAR_AUTH_SESSION:
      return {
        ...initialState,
        auth: null,
        profile: null,
      };
    case SET_LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_LOGIN_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};
export default loginReducer;
